import React, { useEffect } from 'react';
import styles from './index.module.less';
import { useTranslation } from 'react-i18next';
import { getReverseSearchAgreementApi, putReverseSearchAgreementApi } from '@/lib/service/image-search';
import { useUserProvider } from '@/context/UserProvider';

interface Props {
  isAgreePrivacy: boolean;
  setIsAgreePrivacy: (isAgreePrivacy: boolean) => void;
  setIsShowTermsOfUseModel: (isShowTermsOfUseModel: boolean) => void;
  // 是否在仪表盘页面
  isInDashboard?: boolean;
}

const Index: React.FC<Props> = ({ isAgreePrivacy, setIsAgreePrivacy, setIsShowTermsOfUseModel, isInDashboard = false }) => {
  const { isLogin } = useUserProvider();
  const { t } = useTranslation();

  const handleChange = () => {
    setIsAgreePrivacy(!isAgreePrivacy);
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    setIsShowTermsOfUseModel(true);
  };

  // 获取当前用户的隐私协议勾选状态
  useEffect(() => {
    if (isLogin) {
      getReverseSearchAgreementApi().then((res) => {
        if (res.code === 0) {
          setIsAgreePrivacy(res.data.agreed);
        }
      });
    }
  }, [isLogin]);

  // 修改用户同意协议状态
  useEffect(() => {
    if (isLogin) {
      putReverseSearchAgreementApi({ agreed: isAgreePrivacy });
    }
  }, [isAgreePrivacy]);

  return (
    <div className={styles.wrapper}>
      <label className={`${styles.bottomIntro} ${isInDashboard ? styles.dashboardMode : ''}`}>
        <input type="checkbox" className={styles.checkbox} checked={isAgreePrivacy} onChange={handleChange} />
        <span className={styles.text}>
          {t('I agree to the')}{' '}
          <span className={styles.link} onClick={handleLinkClick}>
            {t('terms of use')}
          </span>
        </span>
      </label>
    </div>
  );
};

export default Index;
